import { PlatformFeeActionType } from '../action-types'
import { PlatformFeeReducerStateType } from '../state-types'

const PF_SESSION_ATTRIBUTE = 'pf_opted_out'

// Check sessionStorage for persisted opt-out on init
const getInitialOptOutState = (): { isUsingPlatformFee: boolean } => {
    try {
        const stored = sessionStorage.getItem(PF_SESSION_ATTRIBUTE)
        if (stored === 'true') {
            return { isUsingPlatformFee: false }
        }
    } catch { /* sessionStorage unavailable */ }
    return { isUsingPlatformFee: true }
}

const initOptOut = getInitialOptOutState()

const initialState: PlatformFeeReducerStateType = {
    isUsingPlatformFee: initOptOut.isUsingPlatformFee,
    platformFeeAmount: 0,
    fullBillPfAmount: 0,
    lastPlatformFeeAmount: 0,
    isApplicable: false,
    baseAmount: 0
}

const PlatformFeeReducer = (state: PlatformFeeReducerStateType = initialState, action: any): PlatformFeeReducerStateType => {
    switch (action.type) {
        case PlatformFeeActionType.SET_PLATFORM_FEE:
            return {
                ...state,
                isApplicable: action.payload.isApplicable,
                platformFeeAmount: action.payload.platformFeeAmount,
                baseAmount: action.payload.baseAmount ?? 0
            }
        case PlatformFeeActionType.SET_FULL_BILL_PF:
            return {
                ...state,
                fullBillPfAmount: action.payload.fullBillPfAmount
            }
        case PlatformFeeActionType.SET_OPTED_OUT:
            // Persist opt-out to sessionStorage so it survives page refresh
            try { sessionStorage.setItem(PF_SESSION_ATTRIBUTE, 'true') } catch { /* noop */ }
            return {
                ...state,
                isUsingPlatformFee: false,
                platformFeeAmount: 0
            }
        case PlatformFeeActionType.SET_LAST_PF_AMOUNT:
            return {
                ...state,
                lastPlatformFeeAmount: action.payload.lastPlatformFeeAmount
            }
        case PlatformFeeActionType.RESET:
            return { ...initialState }
        default:
            return state
    }
}

export default PlatformFeeReducer
